import axios from "axios";
import moment from "moment";
import { getLocalStorage } from "./localStorage";
import { LOGIN, REFRESH_TOKEN } from "./urls";
import jwt_decode from "jwt-decode";
import {useHistory} from 'react-router-dom'

export interface DecodedJwtToken {
  exp: number;
}

export const apiConfigOptions = {
  headers: {
    "Content-type": "application/json",
  },
};

export const backendUrl = process.env.REACT_APP_END_POINT;

const axiosApiInstance = axios.create();

export function SetupApiInterceptor() {

  // Request interceptor for API calls
  axiosApiInstance.interceptors.request.use(
    async (config) => {
      let headers;

      if (config && config.url) {
        const startsWithHttpOrHttpsRegex = new RegExp("^((http|https)://)");
        try {
          const expireIn = getLocalStorage("expireIn");
          if (moment.unix(Number(expireIn)).isBefore(moment()) && !config.url.includes(LOGIN)) {
            const refreshToken = getLocalStorage("refreshToken");
            const res = await axios.post(
              `${process.env.REACT_APP_END_POINT}${REFRESH_TOKEN}`,
              {},
              {
                headers: {
                  Authorization: `Bearer ${refreshToken}`,
                },
              }
            );

            const decodedJwtToken: DecodedJwtToken = jwt_decode(
              res.data.results.access_token
            );
            localStorage.setItem("expireIn", decodedJwtToken.exp.toString());
            localStorage.setItem("authToken", res.data.results.access_token);
          }
        } catch (e) {
          localStorage.removeItem("authToken");
          localStorage.removeItem("refreshToken")
          window.location.href = "http://localhost:3000/login"
        }

        if (!startsWithHttpOrHttpsRegex.test(config.url)) {
          if (config.url.startsWith(`/`)) {
            config.url = backendUrl + config.url;
          } else {
            config.url = backendUrl + "/" + config.url;
          }
        }

        headers = apiConfigOptions.headers;
        if (!config.url.includes(LOGIN)) {
          const accessToken = getLocalStorage("authToken");

          if (accessToken && accessToken !== "") {
            headers = { ...headers, Authorization: `Bearer ${accessToken}` };
          }
        }
      }
      config.headers = headers;
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );
}

export default axiosApiInstance;
